import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Request Interceptor
api.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const accessToken = localStorage.getItem("parent_token")
    if (accessToken) {
      config.headers["Authorization"] = accessToken;
    }
    // You can also check if the token needs refreshing here
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  function (response) {
    // Any status code within the range of 2xx causes this function to trigger
    // Do something with response data
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    // Any status codes outside the range of 2xx cause this function to trigger
    // Do something with response error

    // Example of handling a 401 Unauthorized response
    if (error.response.status === 401 && !originalRequest._retry) {
		originalRequest._retry = true;
		
		try {
			const currentToken = localStorage.getItem("parent_token");
			if (!currentToken) {
				// No token to refresh, redirect to login
				localStorage.removeItem("parent_token");
				localStorage.removeItem("parent_user");
				window.location.href = "/login";
				return Promise.reject(error);
			}

			// Attempt to refresh the token
			const refreshResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/refresh-token/`, {},
			{
				headers: {
					'Authorization': currentToken,
					'accept': 'application/json',
					'Content-Type': 'application/json'
				}
			}
			);

			// Extract new token and user data from response
			const newToken = refreshResponse.data.token;
			const userData = refreshResponse.data.user;

			// Update localStorage with new token and user data
			localStorage.setItem("parent_token", newToken);
			localStorage.setItem("parent_user", JSON.stringify(userData));

			// Update the original request with new token
			originalRequest.headers.Authorization = newToken;
			
			// Retry the original request with new token
			return api(originalRequest);
			
		} catch (refreshError) {
			console.error("Token refresh failed:", refreshError);
			// Refresh failed, clear storage and redirect to login
			localStorage.removeItem("parent_token");
			localStorage.removeItem("parent_user");
			localStorage.removeItem("selectedStudent");
			window.location.href = "/login";
			return Promise.reject(refreshError);
		}
    }

    return Promise.reject(error);
  }
);

export default api;
